import { useState, useEffect } from 'react'

/**
 * useMediaQuery Hook
 *
 * Detects if a media query matches
 * @param query - CSS media query string (e.g. "(min-width: 768px)")
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false)

  /* eslint-disable react-hooks/set-state-in-effect */
  useEffect(() => {
    const mediaQuery = window.matchMedia(query)
    setMatches(mediaQuery.matches)

    const handler = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    mediaQuery.addEventListener('change', handler)
    return () => mediaQuery.removeEventListener('change', handler)
  }, [query])
  /* eslint-enable react-hooks/set-state-in-effect */

  return matches
}
